import Config from "../../Config";
import
{
    OAuthConfig
}
from "./config/config";

export const isOauth = () =>
{
    if (!localStorage.getItem('loginMethod'))
    {
        return "unknown logging method";
    }
    if (localStorage.getItem('loginMethod') === "oauth" || localStorage.getItem('loginMethod') === "true")
    {
        return true;
    }
    return false;
}

export const isBasicAuth = () =>
{
    if (!localStorage.getItem('loginMethod'))
    {
        return "unknown logging method";
    }
    if (localStorage.getItem('loginMethod') === "basicauth" || localStorage.getItem('loginMethod') === "false")
    {
        return true;
    }
    return false;
}

export const ADOxxLogout = async () =>
{
    await new Promise(resolve =>
    {
        const lsItems = ["SSO-Credentials", "SSO-codeVerifier", "SSO-codeChallenge", "SSO-ErrorThresholdReached", "ModelSelected", "ObjectSelected"];

        lsItems.forEach((lsItem) =>
        {
            localStorage.removeItem(lsItem);
        })

        resolve();
    });
    window.location.reload(true);
}

export const ClearLocalstorageBeforeLogin = async () =>
{
    await new Promise(resolve =>
    {
        const lsItems = ["ModelSelected", "ObjectSelected"];

        lsItems.forEach((lsItem) =>
        {
            localStorage.removeItem(lsItem);
        })

        resolve();
    });
}

export const isDialog = (sUrl) =>
{
    if (sUrl.includes("isDialog"))
    {
        return true;
    }
    return false;
}

export const urlContain = (aParam) =>
{
    const url = window.location.href;

    return url.includes(aParam);
}

export const ADOxxWindowRedirect = () =>
{
    try
    {

        Config.getConfigEnv().then(() =>
        {
            if (Config.env.WRC_OAUTH_ID)
            {
                window.location.href = Config.baseURL.concat(`/oauth2/authorize?client_id=${Config.env.WRC_OAUTH_ID}&response_type=${OAuthConfig.httpData.response_type}&state=${OAuthConfig.httpData.state}&code_challenge=${localStorage.getItem('SSO-codeChallenge')}&code_challenge_method=${OAuthConfig.httpData.code_challenge_method}`)
            }
        });

    }
    catch (error)
    {
        console.error(error);
    }
};

export const checkToken = async (method) =>
{
    const sCredentials = JSON.parse(localStorage.getItem("SSO-Credentials"));

    if (method === "force")
    {
        return new Promise(async (resolve, reject) =>
        {
            await refreshToken()
                .then((response) =>
                {
                    resolve(response);
                })
            reject(response)
        })
    }

    return new Promise(async (resolve, reject) =>
    {

        if (!sCredentials) reject("Missing credentails");

        try
        {
            fetch(Config.baseURL.concat('/rest/2.0/version'),
                {
                    method: 'GET',
                    headers:
                    {
                        Authorization: `Bearer ${sCredentials.access_token}`
                    }
                })
                .then(async (response) =>
                {
                    if (response.ok)
                    {
                        resolve(response)
                    }

                    if (response.status === 400 || response.status === 401)
                    {
                        await refreshToken()
                            .then((response) =>
                            {
                                resolve(response);
                            })
                        reject(response);
                    }
                }).catch((e) =>
                {
                    ADOxxLogout()
                })
        }
        catch (e)
        {
            handleErrorThresholdReached(
            {
                limit: 2
            });
            await refreshToken()
                .then((response) =>
                {
                    resolve(response);
                })
            reject(response);
            console.log(e);
        }

    })

}

export const handleErrorThresholdReached = (aParam) =>
{

    if (!aParam)
    {
        console.log('Missing arguments');
        return;
    }

    const
    {
        limit
    } = aParam;

    try
    {
        if (!localStorage.getItem('SSO-ErrorThresholdReached'))
        {
            localStorage.setItem('SSO-ErrorThresholdReached', "0");
        }

        let SSO_ErrorThresholdReached = parseInt(localStorage.getItem('SSO-ErrorThresholdReached')) + 1;
        localStorage.setItem('SSO-ErrorThresholdReached', SSO_ErrorThresholdReached.toString());

        if (SSO_ErrorThresholdReached > limit)
        {
            ADOxxLogout();
        }
    }
    catch (error)
    {
        console.error("Error Threshold Reached:", error);
    }
}

export const refreshToken = async () =>
{

    const sCredentials = JSON.parse(localStorage.getItem("SSO-Credentials"));

    if (Object.keys(sCredentials).length === 0)
    {
        ADOxxLogout();
    }

    return new Promise(async (resolve, reject) =>
    {
        try
        {

            const response = await fetch(Config.baseURL.concat('/oauth2/token'),
            {
                method: 'POST',
                headers:
                {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: `grant_type=refresh_token&refresh_token=${sCredentials.refresh_token}&client_id=${Config.env.WRC_OAUTH_ID}&code_verifier=${localStorage.getItem('SSO-codeVerifier')}`
            });

            if (response.ok)
            {
                const data = await response.json();
                localStorage.setItem('SSO-Credentials', JSON.stringify(data));
                localStorage.removeItem('SSO-ErrorThresholdReached');

                resolve(
                {
                    ok: true,
                    status: "success",
                    message: 'Token has been refreshed'
                })
            }
            else if (response.status === 400 || response.status === 401)
            {
                reject(
                {
                    ok: false,
                    status: "fail",
                    message: 'Token refresh failed'
                })
            }
            else
            {
                reject('Unexpected error during token refresh');
            }
        }
        catch (e)
        {
            handleErrorThresholdReached(
            {
                limit: 2
            });
            await refreshToken()
                .then((response) =>
                {
                    resolve(response);
                })
            reject(response);
        }

    })
}

export const checkOauthCredentials = async () =>
{
    await Config.getConfigEnv();

    if (!Config.env.WRC_OAUTH_ID) return {
        isOk: false,
        message: Config.strings.messages.login.ErrorEnvID
    }

    return true;
}